<template>
  <div class="main-content">
    <h6 class="text-left">
      {{ 'latest_app_contact' | i18n }}
    </h6>
    <div>
      <b-table :items="items" :fields="fields" :show-empty="true" :empty-text="noTableDataTitle" :empty-filtered-text="noTableDataTitle" :busy="busy">
        <template #cell(lastDataTransfer)="row">
          {{ row.item.lastDataTransfer | formatDate('DD.MM.YY HH:mm') }}
        </template>
      </b-table>
    </div>
    <router-link to="/employees#devices" style="margin: 10px 0" class="float-right">
      {{ 'to_devices' | i18n }}
      <BIconArrowRight />
    </router-link>
  </div>
</template>

<script>
import { BTable, BIconArrowRight } from 'bootstrap-vue';
import { NO_TABLE_DATA_TITLE } from '../../../../../../../constants';

export default {
  name: 'LatestAppContacts',
  components: { BTable, BIconArrowRight },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      fields: [
        { key: 'lastDataTransfer', label: this.$translate('contact_date') },
        { key: 'deviceId', label: 'App Id' },
        { key: 'version', label: this.$translate('version') },
      ],
      noTableDataTitle: this.$translate(NO_TABLE_DATA_TITLE),
    };
  },
};
</script>

<style scoped lang="scss">
.card-bottom {
  position: absolute;
  bottom: 20px;
  right: 30px;
}
</style>
